import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Loader2 } from "lucide-react";

function Loading({ children, links = [] }) {
  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={links || backofficeLinks} />}
      // pageName={{ title: "Loading..." }}
      // paths={[
      //   { name: "Loading..." },
      //   { name: "Loading..." },
      //   { name: "Loading..." },
      // ]}
    >
      <div className="w-full flex justify-center items-center min-h-[400px]">
        {children || (
          <Loader2 className="animate-spin h-6 w-6 text-muted-foreground" />
        )}
      </div>
    </Layout2>
  );
}

export default Loading;
